import React from "react";

function AppAbschluss() {
  return (
    <div className="abschlussBlock">
      <img
        src="/sections/branding/abschluss.png"
        alt="Sax'emble Konzertauftritt"
        loading="lazy"
      />
    </div>
  );
}

export default AppAbschluss;
